import { formatChannelOrderNumber } from "./channelCounter";

const CHANNEL_NUMBER = /^(CS|TW|DL)(?:[B-D])?(?:Z|F)?\d+$/i;
const WORKING_ID = /^(CS|TW|DL)-[a-z0-9]+$/i;

export const isSequentialChannelNumber = (value) => {
  return typeof value === "string" && CHANNEL_NUMBER.test(value.trim());
};

export const channelSequenceFromOrderNumber = (value) => {
  const match = String(value || "").trim().match(/^(?:CS|TW|DL)(?:[B-D])?(?:Z|F)?(\d+)$/i);
  const seq = match ? Number(match[1]) : 0;
  return Number.isFinite(seq) ? seq : 0;
};

export const isWorkingSessionId = (value) => {
  return typeof value === "string" && WORKING_ID.test(value.trim());
};

export const formatSequentialChannelNumber = (value) => {
  if (typeof value !== "string") return value;
  const match = value.trim().match(/^(CS|TW|DL)([B-D])?(Z|F)?(\d+)$/i);
  if (!match) return value;
  const prefix = match[1].toUpperCase();
  const station = (match[2] || "").toUpperCase();
  const training = (match[3] || "").toUpperCase();
  const n = Number(match[4]);
  const display = Number.isFinite(n) && n > 0 ? n : 1;
  return `${prefix}${station}${training}${String(display).padStart(3, "0")}`;
};

// Channel order number: CS001, TW014, DL002. Never a Firestore document id or a working session id.
export const asChannelOrderNumber = (value) => {
  if (typeof value !== "string" || !isSequentialChannelNumber(value)) return "";
  return formatSequentialChannelNumber(value);
};

export const channelOrderNumberFromSequence = (orderChannel, sequence, isTrainingMode = false) => {
  const seq = Number(sequence);
  if (!Number.isFinite(seq) || seq <= 0) return "";
  return asChannelOrderNumber(formatChannelOrderNumber(orderChannel, seq, isTrainingMode));
};

export const kitchenSlipTitle = ({
  isTable = false,
  isDelivery = false,
  isTakeaway = false,
  tableName = "",
  channelOrderNumber = "",
  deliveryLabel = "Delivery",
  takeawayLabel = "Takeaway",
} = {}) => {
  const channelOrder = asChannelOrderNumber(channelOrderNumber);
  if (isTable) {
    const name = String(tableName || "").trim();
    if (name && !isWorkingSessionId(name) && !isSequentialChannelNumber(name)) return name;
    return channelOrder;
  }
  if (channelOrder) return channelOrder;
  if (isDelivery) return deliveryLabel;
  if (isTakeaway) return takeawayLabel;
  return "Counter";
};

export const getSessionDisplayNumber = (session) => {
  if (!session) return null;
  if (isSequentialChannelNumber(session.orderNumber)) return formatSequentialChannelNumber(session.orderNumber);
  if (isSequentialChannelNumber(session.tableName)) return formatSequentialChannelNumber(session.tableName);
  if (isSequentialChannelNumber(session.id)) return formatSequentialChannelNumber(session.id);
  return null;
};
